'use client'

import Link from 'next/link'

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* 404 일러스트 */}
        <div className="mb-8 relative">
          <div className="text-[150px] font-bold text-blue-500/10 leading-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 bg-blue-500/20 rounded-full flex items-center justify-center">
              <svg className="w-12 h-12 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-white mb-4">
          페이지를 찾을 수 없어요
        </h1>

        <p className="text-gray-400 mb-8">
          요청하신 페이지가 존재하지 않거나<br />
          주소가 변경되었을 수 있습니다.
        </p>

        <div className="flex gap-4 justify-center">
          <Link
            href="/"
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg shadow-lg transform transition-all hover:scale-105"
          >
            홈으로 가기
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 bg-slate-700 hover:bg-slate-600 text-white font-semibold rounded-lg shadow-lg transition-colors"
          >
            이전 페이지
          </button>
        </div>

        {/* 추천 링크 */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-sm text-gray-500 mb-4">혹시 이런 페이지를 찾으셨나요?</p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Link href="/matching" className="text-blue-400 hover:text-blue-300 text-sm">
              버디 매칭
            </Link>
            <Link href="/profile" className="text-blue-400 hover:text-blue-300 text-sm">
              프로필
            </Link>
            <Link href="/community" className="text-blue-400 hover:text-blue-300 text-sm">
              커뮤니티
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}